import { useTranslation } from 'react-i18next';
import { Skeleton } from '../../components/Skeleton';
import { SrOnly } from '../../components/SrOnly';
import {
  DummyPageHeader,
  DummyPageHeaderBreadcrumbs,
  DummyPageHeaderContent,
  DummyPageHeaderCta,
  DummyPageHeaderMain,
  DummyPageHeaderMenu,
  HiddenLtMd,
  HiddenMd,
  TextBlock,
  Wrapper,
} from './wrapper';

const SkeletonPageHeader = () => {
  const { t } = useTranslation(['other']);

  return (
    <>
      <SrOnly>{t('skeletonLoading.pageHeader', { ns: 'other' })}</SrOnly>
      <Wrapper>
        <DummyPageHeader>
          <DummyPageHeaderMenu>
            <Skeleton $width="32px" $height="32px" />
          </DummyPageHeaderMenu>
          <DummyPageHeaderBreadcrumbs>
            <Skeleton $width="80px" $height="21px" />
            <Skeleton $width="110px" $height="21px" />
          </DummyPageHeaderBreadcrumbs>
          <DummyPageHeaderMain>
            <DummyPageHeaderContent>
              <HiddenMd>
                <Skeleton $width="250px" $height="40px" />
              </HiddenMd>
              <HiddenLtMd>
                <Skeleton $width="250px" $height="45px" />
              </HiddenLtMd>
              <TextBlock>
                <Skeleton $width="90%" $height="24px" />
                <Skeleton $width="70%" $height="24px" />
              </TextBlock>
            </DummyPageHeaderContent>
            <DummyPageHeaderCta>
              <Skeleton $width="160px" $height="45px" />
            </DummyPageHeaderCta>
          </DummyPageHeaderMain>
        </DummyPageHeader>
      </Wrapper>
    </>
  );
};

export default SkeletonPageHeader;
